module.exports = __webpack_public_path__ + "static/media/garden11.24a29b4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/garden/images/garden11.jpg
// module id = 622
// module chunks = 0